import { Routes, Route, useLocation } from "react-router-dom";
import Home from './Pages/Home';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import Renewal from "./Pages/Plan";
import Payment from "./Pages/Payment";
import Policy from "./Pages/Policy";
import VideoBackground from "./components/VideoBackground";
import V2 from "./Pages/Homev2";
import Motor from "./Pages/Motor";
import Ren from "./Pages/ren";
import Pdf from "./Pages/Pdf";
import Online from "./Pages/Online";
import Success from "./Pages/Success";
import Motorv2 from "./Pages/Motorv2";
import Login from "./Pages/Homev3";
import Scanner from "./Pages/Scanner";

function App() {
  const location = useLocation();

  const showVideoBackground = !["/", "/motor", "/renewal", "/payment", "/approval", "/plan", "/pdf/:id", "/online","/success","/v3","/motorv2","/scanner"].includes(location.pathname);

  return (
    <>
      {!showVideoBackground && <VideoBackground />}

      <Routes>
        <Route path="/v3" element={<Home />} />

        

        <Route path="/" element={<Login />} />
        <Route path="/v2" element={<V2 />} />
        <Route path="/plan" element={<Ren />} />
        <Route path="/motor" element={<Motor />} />
        <Route path="/scanner" element={<Scanner />} />

        <Route path="/motorv2" element={<Motorv2 />} />
        <Route path="/ren" element={<Renewal />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/approval" element={<Policy />} />
        <Route path="/pdf/:id" element={<Pdf />} />
        <Route path="/online/:encryptedData" element={<Online />} />

        <Route path="/success" element={<Success />} />
      </Routes>

      <ToastContainer />
    </>
  );
}

export default App;
